import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, CanDeactivate, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { NavigationInterventionService } from '../services/navigation-intervention.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationInterventionGuard implements CanDeactivate<unknown> {
  constructor(
    protected readonly router: Router,
    private readonly beforeUnloadService: NavigationInterventionService,
    private matDialog: MatDialog,
  ) {}

  public canDeactivate(
    _component: unknown,
    _currentRoute: ActivatedRouteSnapshot,
  ): ReturnType<CanDeactivate<NavigationInterventionService>['canDeactivate']> {
    return this.beforeUnloadService.getNavigationInterventionObservable().pipe(
      map((action) => {
        if (action !== undefined) {
          this.matDialog.closeAll();
        }

        return action !== undefined;
      }),
    );
  }
}
